import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { SubscriptionQc } from "models/subscription-qc";
import { useAuth } from "src/contexts/AuthContext";

export const useSubscriptionQcRequests = () => {
  const [subscriptionQcRequests, setSubscriptionQcRequests] = useState<
    SubscriptionQc[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { fetchWithReauth } = useAuth();

  const fetchSubscriptionQcRequestsByMonth = async (yearMonth?: string) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (yearMonth) {
        queryParams.append("yearMonth", yearMonth);
      }

      const response = await fetchWithReauth(
        `${API_URL}/invoices/subscription-qc?${queryParams.toString()}`,
        { method: "GET" }
      );
      const data = await checkResponse(response);
      setSubscriptionQcRequests(data.items);
    } catch (error) {
      console.error("Error fetching subscription QC requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionQcRequestsByMonth(); // Fetch for the current month by default
  }, []);

  return {
    subscriptionQcRequests,
    loading,
    fetchSubscriptionQcRequestsByMonth,
  };
};
